// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/task.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.app.v1.TaskAuditSuccessResult
 */
export interface TaskAuditSuccessResult {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 100;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.TaskAuditErrorResult
 */
export interface TaskAuditErrorResult {
    /**
     * TODO(pquerna): expand
     *
     * @generated from protobuf field: int64 error_count = 1;
     */
    errorCount: number;
    /**
     * @generated from protobuf field: string error_reason = 2;
     */
    errorReason: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.TaskAuditCancelledResult
 */
export interface TaskAuditCancelledResult {
}
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditSuccessResult$Type extends MessageType<TaskAuditSuccessResult> {
    constructor() {
        super("c1.api.app.v1.TaskAuditSuccessResult", [
            { no: 100, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TaskAuditSuccessResult
 */
export const TaskAuditSuccessResult = new TaskAuditSuccessResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditErrorResult$Type extends MessageType<TaskAuditErrorResult> {
    constructor() {
        super("c1.api.app.v1.TaskAuditErrorResult", [
            { no: 1, name: "error_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "error_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TaskAuditErrorResult
 */
export const TaskAuditErrorResult = new TaskAuditErrorResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TaskAuditCancelledResult$Type extends MessageType<TaskAuditCancelledResult> {
    constructor() {
        super("c1.api.app.v1.TaskAuditCancelledResult", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.TaskAuditCancelledResult
 */
export const TaskAuditCancelledResult = new TaskAuditCancelledResult$Type();
